import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import WhyUs from "../components/WhyUs";
import Testimonials from "../components/Testimonials";
import Sustainability from "../components/Sustainability";
import Coverage from "../components/Coverage";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Chatbot from "../components/Chatbot";
import JsonLd from "../components/JsonLd";
import { SERVICES } from "../lib/services";

const businessJsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://green-route.co.za/#business",
  name: "Greenroute Estate Management Services",
  legalName: "Greenroute Estate Management Services (Pty) Ltd",
  description:
    "Comprehensive maintenance, repairs and management for residential and commercial complexes across South Africa.",
  url: "https://green-route.co.za/",
  telephone: "+27661833893",
  email: "admin@green-route.co.za",
  foundingDate: "2024-06-21",
  slogan: "Managed with Precision. Built on Trust.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Cnr John & Earp Street, Selby",
    addressLocality: "Johannesburg",
    addressRegion: "Gauteng",
    postalCode: "2001",
    addressCountry: "ZA",
  },
  areaServed: [
    { "@type": "AdministrativeArea", name: "Gauteng" },
    { "@type": "AdministrativeArea", name: "Western Cape" },
    { "@type": "AdministrativeArea", name: "KwaZulu-Natal" },
    { "@type": "AdministrativeArea", name: "Eastern Cape" },
  ],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Estate Management Services",
    itemListElement: SERVICES.map((s, i) => ({
      "@type": "Offer",
      position: i + 1,
      itemOffered: {
        "@type": "Service",
        name: s.title,
        url: `https://green-route.co.za/services/${s.slug}`,
        description: s.short,
      },
    })),
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+27661833893",
    contactType: "customer service",
    areaServed: "ZA",
    availableLanguage: ["English"],
  },
};

const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  url: "https://green-route.co.za/",
  name: "Greenroute Estate Management Services",
};

export default function HomePage() {
  return (
    <main className="bg-cream" data-testid="home-page">
      <JsonLd id="business-jsonld" data={businessJsonLd} />
      <JsonLd id="website-jsonld" data={websiteJsonLd} />
      <Navbar />
      <Hero />
      <About />
      <Services />
      <WhyUs />
      <Testimonials />
      <Sustainability />
      <Coverage />
      <Contact />
      <Footer />
      <Chatbot />
    </main>
  );
}
